const texts = {
  title: 'Move {coach} to the pool?',
  titleMultiple: 'Move {count} coaches to the pool?',
  description: 'A coach is either in the pool or with a dedicated AC — never both. Adding to the pool removes their '
    + 'current AC assignments and hands the coach to the whole AC organization.',
  currentAc: 'AC: {acNames}',
  currentAcs: 'ACs: {acNames}',
  unassigned: 'Unassigned',
  pool: 'Pool',
  confirm: 'Remove ACs & add to pool',
  cancel: 'Cancel',
};

export default texts;
